import React, { useMemo } from 'react';
import { mdiChevronRight } from '@mdi/js';
import Icon from '../icon/Icon';
import { MultiLink } from '../link/MultiLink';
import { COLORS } from '../color';
var BreadcrumbItem = function (_a) {
    var name = _a.name, link = _a.link, isShowChevron = _a.isShowChevron, isActive = _a.isActive, iconPath = _a.iconPath, iconColor = _a.iconColor, iconSize = _a.iconSize, microdataMetaContent = _a.microdataMetaContent;
    var getBreadcrumbIconNext = useMemo(function () {
        if (isShowChevron) {
            return React.createElement(Icon, { path: mdiChevronRight, color: COLORS.gray600, size: 0.667 });
        }
    }, [isShowChevron]);
    var content;
    if (isActive) {
        content = (React.createElement("p", { itemProp: 'item', className: 'breadcrumb-item-text mb-0 ' + (isActive ? 'active' : '') },
            React.createElement("span", { itemProp: 'name' }, name)));
    }
    else {
        content = (React.createElement(MultiLink, { itemProp: 'item', href: link, type: 'to', className: 'breadcrumb-item-text' + (isActive ? 'active' : '') },
            React.createElement("span", { itemProp: 'name' }, name)));
    }
    return (React.createElement("li", { itemProp: 'itemListElement', itemScope: true, itemType: 'https://schema.org/ListItem' },
        iconPath && React.createElement(Icon, { path: iconPath, color: iconColor, size: iconSize }),
        content,
        React.createElement("meta", { itemProp: 'position', content: microdataMetaContent.toString() }),
        getBreadcrumbIconNext));
};
export { BreadcrumbItem };
//# sourceMappingURL=BreadcrumbItem.js.map